import request from '@/utils/request'

export const sendEmail = (id: string) =>
  request({
    url: `/admin/deposit_invoices/${id}/send_email`,
    method: 'post'
  })

export const generate = (id: string) =>
  request({
    url: `/admin/deposit_invoices/${id}/generate`,
    method: 'get'
  })
